import * as React from 'react';
import { getSEGenericDropdownValues } from 'src/api/shipmentExecution';
import { useFieldProps } from 'src/hooks/form/useField';
import { useStaticSelect } from 'src/hooks/form/useSelect';
import { KeyLabel } from 'src/Library/Types';
import message from 'antd/lib/message';

const useSEGenericDropdown = (
  props: useFieldProps<{ type: string; shipmentExecutionId: string, values: string[] }>
  ) => {
  const field = useStaticSelect(props);
  const { type, shipmentExecutionId } = props.extraData || {};
  
  /** using type to fetch dropdown values */
  const loadData = async () => {
    if (!type || !shipmentExecutionId) return;
    const response = await getSEGenericDropdownValues({type, shipmentExecutionId});
    if (response.isSuccess) {
      field.setOptionsData(response?.data, data => data as KeyLabel[]);
    } else {
      message.error(response.errorMessage);
    }
  }

  React.useEffect(() => {
    loadData();
  }, [type, shipmentExecutionId]);

  React.useEffect(() => {
    const keys = (field.optionsData as (KeyLabel[] | undefined) || []).map(options => options.key);
    const values = props.extraData?.values?.filter(val => keys.includes(val));
    field.setValue(values);
  }, [field.optionsData]);

  return {
    ...field,
    fieldType: 'multiSelect',
  };
};

export default useSEGenericDropdown;
